import React from "react";
import styled from "styled-components";
import { useState } from "react";
import AWS from "aws-sdk";
import * as XLSX from "xlsx";
import { Buffer } from "buffer";

AWS.config.update({
  accessKeyId: "AKIAWCZC523CPFGSHMG6",
  secretAccessKey: "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",
  region: "us-east-1",
});

const s3 = new AWS.S3();

const formations = [
  "Sauveteur Secouriste du Travail (SST)",
  "Intelligence Artificielle (IA)",
  "Bureautique",
  "Langues",
  "Soft Skills",
  "Management/RH",
  "Infographie",
  "Productivité de l’entreprise",
  "Comptabilité/Paie",
  "Reconversion Professionnelle",
  "CAO-DAO",
  "Soins Infirmiers",
  "Développement Web",
  "Kinésithérapie",
  "Vente/Marketing Digital",
  "Sécurité",
  "Autres",
];

const ContactSection = () => {
  const [formData, setFormData] = useState({
    nom: "",
    prenom: "",
    adresse: "",
    email: "",
    telephone: "",
    activite: "",
    raisonSociale: "",
    formation: "",
  });
  const [formation, setFormation] = useState("");

  const handleSubmit = async (e) => {
    console.log("Form data:", formData);
    try {
      // Generate Excel file
      const ws = XLSX.utils.json_to_sheet([formData]);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "Contact");

      // Convert to binary data
      const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });

      // Create a Blob
      const file = new Blob([excelBuffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });

      // Convert Blob to base64
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onloadend = async () => {
        const base64Data = reader.result.split(",")[1]; // Remove data URL prefix
        await uploadExcelToS3(base64Data);
      };
    } catch (error) {
      console.error("Error generating Excel file:", error);
    }
  };

  // Function to upload Excel file to AWS S3
  const uploadExcelToS3 = async (base64Data) => {
    console.log("Uploading Excel file to S3...");

    try {
      // Convert base64 string to buffer
      const fileContentBuffer = Buffer.from(base64Data, "base64");

      // Define S3 upload parameters
      const params = {
        Bucket: "valacademy", // Replace with your S3 bucket name
        Key: `Excel/Contact_${Date.now()}.xlsx`, // Use .xlsx extension for Excel files
        Body: fileContentBuffer,
        ContentType:
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        ACL: "public-read", // Make the file publicly accessible
      };

      // Upload to S3 using promise-based syntax
      const data = await s3.upload(params).promise();
      console.log("Successfully uploaded Excel file:", data.Location);

      // Call API to send email
      const response = await fetch(
        "https://7qhcbncwbj.execute-api.us-east-1.amazonaws.com/dev/oxygenefm/auth/valAcademyEmail",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            name: formData.nom + " " + formData.prenom,
            url: data.Location,
          }),
        }
      );

      const result = await response.json();
      if (result.success) {
        alert("Email envoyé avec succès !");
      } else {
        alert("Échec de l'envoi de l'email.");
      }
    } catch (error) {
      console.error("Error:", error);
      alert("An error occurred.");
    }
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  return (
    <div className="homeImages">
      <img
        src={require("../../assets/img/Rotation/Learning.webp")}
        alt="Formation professionnelle chez Valacademy Formations pour booster votre carrière"
        className="backgroundImg"
      />
      <Wrapper>
        <LeftSection>
          <ContactForm>
            <MobileText>
              <h1
                style={{
                  color: "#FF9900", // your orange color
                  fontSize: "2rem", // larger size
                  fontWeight: "700", // bold
                  textTransform: "uppercase", // all caps
                  letterSpacing: "2px", // spacing between letters
                  textAlign: "center", // center it
                  lineHeight: "1.2", // spacing between lines
                  textShadow: "2px 2px 4px rgba(0,0,0,0.3)", // subtle shadow
                }}
              >
                VALACADEMY{" "}
                <span
                  style={{
                    display: "block",
                    fontSize: "2rem",
                    fontWeight: "500",
                    marginTop: "0.5rem",
                  }}
                >
                  FORMATIONS
                </span>
              </h1>
            </MobileText>

            <h2 style={{ fontWeight: "bold" }}>Je m'inscris à une formation</h2>
            <form>
              <InputRow>
                <InputField
                  type="text"
                  placeholder="Nom"
                  aria-label="Nom"
                  name="nom"
                  required
                  onChange={handleChange}
                />
                <InputField
                  type="text"
                  placeholder="Prénom"
                  aria-label="Prénom"
                  name="prenom"
                  required
                  onChange={handleChange}
                />
              </InputRow>

              <InputRow>
                <InputField
                  type="text"
                  placeholder="Raison Sociale"
                  aria-label="Raison Sociale"
                  name="raisonSociale"
                  required
                  onChange={handleChange}
                />
              </InputRow>

              <InputRow>
                <InputField
                  type="text"
                  placeholder="Activité"
                  aria-label="Activité"
                  name="activite"
                  required
                  onChange={handleChange}
                />
                <InputField
                  type="text"
                  placeholder="Adresse"
                  aria-label="Adresse"
                  name="adresse"
                  required
                  onChange={handleChange}
                />
              </InputRow>

              <InputRow>
                <InputField
                  type="email"
                  placeholder="Email"
                  aria-label="Email"
                  name="email"
                  required
                  onChange={handleChange}
                />
                <InputField
                  type="tel"
                  placeholder="Téléphone"
                  aria-label="Téléphone"
                  name="telephone"
                  required
                  onChange={handleChange}
                />
              </InputRow>

              {/* <InputRow>
                <Textarea placeholder="Sujet"></Textarea>
              </InputRow> */}

              <SelectInput
                aria-label="Choisir votre formation"
                name="formation"
                onChange={(e) => {
                  e.target.style.color = e.target.value ? "black" : "gray";
                  setFormData((prevData) => ({
                    ...prevData,
                    formation: e.target.value,
                  }));
                }}
              >
                <option value="" disabled selected>
                  Choisir Votre Formation
                </option>
                {formations.map((formation, index) => (
                  <option key={index} value={formation}>
                    {formation}
                  </option>
                ))}
              </SelectInput>
              <div
                style={{ marginTop: "-5px", marginBottom: "10px" }}
                className={`fade-container ${
                  formation === "Autres" ? "show" : ""
                }`}
              >
                <InputRow>
                  <InputField
                    type="text"
                    placeholder="Saisir Votre Formation"
                  />
                </InputRow>
              </div>
              <SubmitButton
                type="button"
                onClick={() => {
                  handleSubmit();
                }}
              >
                Inscription
              </SubmitButton>
            </form>
          </ContactForm>
        </LeftSection>
        <RightSection>
          <div>
            <h1 style={{ color: "rgb(255, 153, 0)" }}>
              VALACADEMY <span style={{ display: "block" }}>FORMATIONS</span>
            </h1>

            <p>
              Découvrez une large gamme de formations professionnelles
              subventionnées par les OPCO pour booster votre carrière.
            </p>
          </div>
        </RightSection>
      </Wrapper>
    </div>
  );
};

export default ContactSection;
const Wrapper = styled.div`
  display: flex;
  height: 120vh;
  width: 100vw;
  margin-top: 8%;
`;
const LeftSection = styled.div`
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 10px;
  background: linear-gradient(
    to left,
    rgba(0, 0, 0, 0) 0%,
    rgb(255, 153, 0) 100%
  );
  ${"" /* backdrop-filter: blur(5px); */}
`;
const ContactForm = styled.div`
  width: 90%;
  max-width: 500px;
  background: rgba(255, 255, 255, 0.18);
  padding: 40px;
  border-radius: 16px;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.1);
  transform: translateY(10px);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  position: relative;
  @media (max-width: 640px) {
    font-size: 0.95rem;

    input,
    select {
      padding: 8px;
    }
  }

  &:hover {
    transform: translateY(-5px);
    box-shadow: 0 20px 60px rgba(0, 0, 0, 0.15);
  }

  h2 {
    text-align: center;
    font-size: clamp(1.5rem, 4vw, 2rem); /* Responsive font size */
    margin-bottom: 20px;
    color: #333;
    font-weight: bold;
  }

  @media (max-width: 600px) {
    padding: 30px;
  }
`;
const InputRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 15px;
  width: 100%;
  margin-top: 10px;
  padding-bottom: 5px;

  & > * {
    flex: 1;
    min-width: calc(50% - 8px); /* Half width minus half gap */
  }

  @media (max-width: 480px) {
    & > * {
      min-width: 100%; /* Full width on very small screens */
    }
  }
`;

const InputField = styled.input`
  flex: 1; /* Ensures equal width for inputs in a row */
  min-width: 0; /* Prevents overflow issues */
  padding: 15px;
  border: 2px solid #ddd;
  border-radius: 12px;
  font-size: 1rem;
  background-color: #f9f9f9;
  color: #333;
  transition: all 0.3s ease;

  &:focus {
    border-color: #007bff;
    outline: none;
    background-color: #f0f9ff;
  }

  &::placeholder {
    color: #aaa;
  }
`;

// const Textarea = styled.textarea`
//   flex: 1; /* Ensures equal width for inputs in a row */

//   padding: 15px;
//   margin-bottom: 10px;
//   border: 2px solid #ddd;
//   border-radius: 12px;
//   font-size: 1rem;
//   background-color: #f9f9f9;
//   color: #333;
//   resize: none;
//   transition: all 0.3s ease;
//   line-height: 1.5;
//   font-family: Arial, sans-serif;
//   justifycontent: center;

//   &:focus {
//     border-color: #007bff;
//     outline: none;
//     background-color: #f0f9ff;
//   }

//   &::placeholder {
//     color: #aaa;
//     font-size: 1rem;
//   }
// `;

const MobileText = styled.div`
  display: none; /* Hidden by default */

  @media (max-width: 768px) {
    display: block; /* Show on mobile screens */
    text-align: center;
    padding: 20px;
    color: rgb(255, 115, 0);
    width: 100%; /* Ensure it takes full width */
    h1,
    h2 {
      color: rgb(255, 81, 0);
    }

    p {
      margin-top: 10px;
    }
  }
`;

const SelectInput = styled.select`
  width: 100%;
  padding: 18px 15px; /* Increased vertical padding */
  margin-bottom: 10px;
  border: 2px solid #ddd;
  border-radius: 12px;
  font-size: 1rem;
  background-color: #f9f9f9;
  transition: all 0.3s ease;
  color: gray;
  margin-top: 10px;

  &:focus {
    border-color: #007bff;
    background-color: #f0f9ff;
    outline: none;
  }

  option {
    color: black;
  }
`;

const SubmitButton = styled.button`
  width: 100%;
  padding: 12px;
  background-color: #007bff;
  border: none;
  color: white;
  font-size: 1.2rem;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s ease;
  font-weight: 600;

  &:hover {
    background-color: #0056b3;
    transform: translateY(-3px);
  }

  &:active {
    background-color: #004085;
    transform: translateY(1px);
  }

  @media (max-width: 480px) {
    font-size: 1rem;
    padding: 14px;
  }
`;
const RightSection = styled.div`
  flex: 1;
  background-size: cover;
  background-position: center;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0 100px;
  color: white;
  text-align: center;

  @media (max-width: 768px) {
    display: none; /* Hides the section on smaller screens */
  }

  @media (max-width: 1200px) {
    padding: 0 20px;
  }

  h1 {
    font-size: 3rem;
    font-weight: bold;
    position: relative;
    z-index: 1;
  }

  h2 {
    font-size: 2.5rem;
    font-weight: bold;
    position: relative;
    z-index: 1;
  }

  p {
    margin-top: 15px;
    font-size: 1.2rem;
    color: #d1d1d1;
    position: relative;
    z-index: 1;
  }
`;
